import cn from "classnames"

interface Props {
    fullscreen?: boolean
    text?: string
    size?: number
    className?: string
}

export function Spinner(props: Props) {
    const styles = props.size ? { width: props.size, height: props.size } : {}
    return (
        <div
            className={cn("spinner-redesign mg-auto", props.className, {
                ["fullscreen"]: props.fullscreen,
            })}
        >
            <div className="spinner-redesign__ring" style={styles}>
                <div style={styles} />
                <div style={styles} />
                <div style={styles} />
                <div style={styles} />
            </div>
            {props.text && <div className="spinner-redesign__text">{props.text}</div>}
        </div>
    )
}
